// ======================================================================
// File Name       : superuser
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function postSuperUserEdit(data) {
  return commonCallApi({
    enterpriseId: true,
    path: 'superuser/Edit',
    data: { ...data },
  });
}

export function postSuperUserGetList(data) {
  return commonCallApi({
    enterpriseId: true,
    path: 'superuser/GetList',
    data: { ...data },
  });
}

export function postIntegrationUserEdit(data) {
  return commonCallApi({
    enterpriseId: false,
    path: 'integrationuser/Edit',
    data: { ...data },
  });
}
